import React, { useEffect, useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import { Accordion, Form } from 'react-bootstrap';
import 'react-multi-carousel/lib/styles.css';

//component
import Banner from '../banner/banner'
import AboutUs from './about-list/AboutUs'



function About() {
 

  return (
    <>
    <div className='container bg-white p-3 m-3'>
      <div className='title pb-2'>
        <h6>صفحه درباره ما</h6>
      </div>
      <div className=''>
      <Accordion  >
          <div className=' [&>div]:px-2 [&>div]:py-3'>
            <div className='12'>
              <Accordion.Item eventKey="0">
                <Accordion.Header>بنر صفحه درباره ما</Accordion.Header>
                <Accordion.Body>
                <Banner slug="aboutUs1"/>
                </Accordion.Body>
              </Accordion.Item>
            </div>
      
            <div>
              <Accordion.Item eventKey="2">
                <Accordion.Header>متن درباره ما</Accordion.Header>
                <Accordion.Body>
                    <AboutUs/>
                </Accordion.Body>
              </Accordion.Item>
            </div>
            {/* <div>
              <Accordion.Item eventKey="3">
                <Accordion.Header>نظرات ثبت شده بر روی محصولات</Accordion.Header>
                <Accordion.Body>
                    <Comment/>
                </Accordion.Body>
              </Accordion.Item>
            </div> */}
           
          </div>
        </Accordion>
      </div>
    </div>
    </>
  );
}

export default About;
